import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { Answer, QuestionInPage, QuestionnaireAnswer } from 'src/app/core/models/questionnaire.model';

@Component({
  selector: 'app-edit-single-question',
  templateUrl: './edit-single-question.component.html',
  styleUrls: ['./edit-single-question.component.scss'],
})
export class EditSingleQuestionComponent implements OnInit{
  // last change emitted by the inner question component
  lastChange: { question: any; answer: Answer } | null = null;

  // provide a null observable for questionnaireAnswer (question.component expects an Observable)
  qa$: Observable<QuestionnaireAnswer | null> = of(null);

  constructor(
    public dialogRef: MatDialogRef<EditSingleQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { question: QuestionInPage }
  ) {}

  ngOnInit(): void {
    console.log('[EditSingleQuestionComponent] DATA', this.data);
  }

  onChange(ev: any) {
    this.lastChange = ev;
  }

  closeCancel() {
    this.dialogRef.close({ ok: false });
  }

  saveAndClose() {
    this.dialogRef.close({ ok: true, change: this.lastChange });
  }
}
